module.exports = __webpack_public_path__ + "assets/cde5db6ceaff46432d2f22e9517068c7.png";